import type React from "react";
import classNames from "classnames";

export type RegionProps = {
  onHover: (value: boolean) => void;
  url: string | undefined;
  children: React.ReactNode;
  isSelected: boolean;
};

export const BaseRegion = ({
  url,
  onHover,
  children,
  isSelected,
}: RegionProps) => {
  return (
    <a
      href={url}
      className={classNames(isSelected && "activeCountryOutline")}
      onMouseEnter={() => onHover(true)}
      onMouseLeave={() => onHover(false)}
    >
      {children}
    </a>
  );
};
